import { make } from "vuex-pathify";

const state = {
	show: false,
	articles: []
};

const getters = {};

const mutations = {
	...make.mutations(state)
};

const actions = {
	/**
	 * Shows/opens BulkDialog component and sets initial values
	 * articles - Array of articles selected, or array of one article
	 */
	openArticleRefetchStatsDialog({ commit }, articles) {
		commit('SET_SHOW', true);
		commit('SET_ARTICLES', articles);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
